const CENTS_PER_EURO = 100;

const formatEuros = (fractionDigits: number): Intl.NumberFormat =>
  new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

const WHOLE_EURO_FORMATTER = formatEuros(0);
const EURO_WITH_CENTS_FORMATTER = formatEuros(2);

export const formatEurosCents = (cents: number | null | undefined): string => {
  if (cents === null || cents === undefined) return "";
  const formatter = cents % CENTS_PER_EURO === 0 ? WHOLE_EURO_FORMATTER : EURO_WITH_CENTS_FORMATTER;
  return formatter.format(cents / CENTS_PER_EURO);
};

export const applyDiscountPercent = (cents: number, percent: number): number =>
  Math.round(cents * (1 - percent / 100));
